'use client';
import CartIcon from '@repo/ui/src/components/Icons/CartIcon';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useBasket from '@hooks/basket/useBasket';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';

const NavbarShoppingCart = () => {
  const { eCommEnabled } = useCurrentUrl();
  const { data: basket } = useBasket();
  const { push } = useModal(ModalID.cart);
  if (!eCommEnabled) {
    return null;
  }

  const basketSize = basket?.totalItems ?? 0;
  return (
    <button
      role="link"
      id="commerceMenu"
      aria-label={`Shopping cart, ${basketSize} items`}
      onClick={push}
      className="tw-p-3 tw-relative tra-btn-bare tw-rounded"
    >
      <CartIcon className="tw-text-white tw-w-6" />
      {basket && (
        <span
          aria-hidden
          className="tra-text-web-body-s-link !tw-no-underline tw-absolute tw-top-1 tw-right-1 tw-text-white tw-bg-action-500 tw-px-1.5 tw-py-px tw-rounded-full hover:tw-text-white"
        >
          {basketSize}
        </span>
      )}
    </button>
  );
};

export default NavbarShoppingCart;
